import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import dd from 'dingtalk-jsapi'
import VueTinymce from '@packy-tang/vue-tinymce'
import storage from './utils/changeStorage'



Vue.use(ElementUI)
Vue.use(dd)
Vue.config.productionTip = false
Vue.use(VueTinymce)

Vue.prototype.getTimeship = function (time) {
  const date = new Date(time * 1000)
  const Y = date.getFullYear()
  const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const D = date.getDate()
  const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return `${Y}-${M}-${D} ${h}:${m}:${s}`
}

Vue.prototype.getStatus = function (table) {
  table.forEach(item => {
    item.create_time = this.getTimeship(item.create_time)
    // todo : 使用switch替换
    if (item.status == 1) {
      item.status = '未受理'
    } else if (item.status == 2) {
      item.status = '已受理'
    } else if (item.status == 3) {
      item.status = '已退回'
    } else if (item.status == 5) {
      item.status = '待归档'
    }else if(item.status == 6 ){
      item.status = '已完结'
    }
  })
}

Vue.prototype.$storage = storage

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
